module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-2-bfc317f820ea6129dfe8ce1b055b6a44.jpg";